import React from 'react';
import { useTranslation } from 'react-i18next';
import LifecycleTypeTab from './LifecycleTypeTab';
import { getMovementTypes, addMovementType, updateMovementType, deleteMovementType } from '../../../../../api/Employee/lifecycleSettings';

const MovementTypesTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LifecycleTypeTab
      title={t('Movement Types')}
      description={t('Configure types of internal movements such as promotions, transfers, and demotions')}
      emptyMessage={t('No movement types configured yet')}
      emptyIcon="ArrowRightLeft"
      addLabel={t('Add Movement Type')}
      editLabel={t('Edit Movement Type')}
      deleteLabel={t('Delete Movement Type')}
      nameLabel={t('Movement type name')}
      namePlaceholder={t('e.g., Promotion')}
      successAddMessage={t('Movement type added successfully')}
      successUpdateMessage={t('Movement type updated successfully')}
      successDeleteMessage={t('Movement type deleted successfully')}
      failAddMessage={t('Failed to save movement type')}
      failDeleteMessage={t('Failed to delete movement type')}
      deleteConfirmMessage={t('Are you sure you want to delete')}
      duplicateMessage={t('A movement type with this name already exists')}
      fetchItems={getMovementTypes}
      addItem={addMovementType}
      updateItem={updateMovementType}
      deleteItem={deleteMovementType}
      testIdPrefix="movement-type"
    />
  );
};

export default MovementTypesTab;
